import { AppConfig } from '../../../app-config'
import getUserDetails from '../../../utils/actions/getUserDetails'
import { getLeadSource } from '../../../utils/analytics/leadSourceHelper'
import { triggerSimpleAjax } from '../../../utils/http-helper'
import { triggerLogin } from './login'

const API_URL = AppConfig.api_url

export const triggerRquestCallback = ({
	reqObj = {},
	successSubmitCallback,
	failureSubmitCallback,
	router,
	dispatch,
	userDetails,
	leadSourceData = {},
	ignoreLogin,
	locale,
}) => {
	let url = `${API_URL}itinerary/requestcallbackuser`
	return new Promise((resolve, reject) => {
		const leadSource = getLeadSource({
			router,
		})

		reqObj['leadSource'] = { ...leadSource, ...leadSourceData }
		triggerSimpleAjax({
			url,
			method: 'POST',
			body: reqObj,
			locale: locale,
			onSuccess: response => {
				if (response.status === 'SUCCESS') {
					if (!userDetails?.loggedIn && !ignoreLogin) {
						if (!response.data.newUserCreated) {
							reqObj.password = 'travelisfun'
							triggerLogin({
								reqObj,
								dispatch,
								router,
								successSubmitCallback: userDetails => {
									successSubmitCallback(userDetails)
									resolve()
								},
								failureSubmitCallback: () => {
									failureSubmitCallback(response)
								},
							}).catch(() => {
								failureSubmitCallback(response)
							})
						} else {
							getUserDetails({
								req_data: { prod_type: leadSource.prodType },
								dispatch,
							})
								.then(userDetails => {
									successSubmitCallback(userDetails)
									resolve()
								})
								.catch()
						}
					} else {
						successSubmitCallback(response)
						resolve()
					}
				} else {
					failureSubmitCallback(response)

					// if (
					// 	response.status === 'MOBILE_EXISTS' ||
					// 	response.status === 'EMAIL_EXISTS'
					// ) {
					// 	reqObj.password = 'travelisfun'
					// 	if (response.status === 'MOBILE_EXISTS') {
					// 		delete reqObj.email
					// 	}
					// 	if (response.status === 'EMAIL_EXISTS') {
					// 		delete reqObj.mobileNumber
					// 		delete reqObj.countryPhoneCode
					// 	}
					// 	triggerLogin({
					// 		reqObj,
					// 		dispatch,
					// 		router,
					// 		successSubmitCallback: userDetails => {
					// 			successSubmitCallback(userDetails)
					// 			resolve()
					// 		},
					// 		failureSubmitCallback: () => {
					// 			failureSubmitCallback(response)
					// 		},
					// 	})
					// } else {
					// 	failureSubmitCallback(response)
					// }
				}
			},
			onFailure: error => {
				failureSubmitCallback({
					mobileNumber: 'Unable to Login. Please try again later.',
				})
				reject(error)
			},
		})
	})
}
